import styled from 'styled-components';
import colors from '@designSystem/colors';
import Button from '@root/src/app/designSystem/buttons';
import { CloseMark } from '@root/src/assets/images';
import { Dropdown } from 'react-bootstrap';

export const StyledCloseMark = styled(CloseMark)`
  & path {
    stroke: ${colors.black};
  }
`;

export const StyledDropdownMenu = styled.div`
  width: fit-content;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  padding: 32px 16px 32px 16px;
  border: none;
  border-radius: 10px;
`;

export const DropdownItem = styled(Dropdown.Item)`
  width: fit-content !important;
  padding: 0.25 rem 1.5 rem;
  white-space: nowrap;
`;

export const StyledButton = styled(Button)<{ noFill?: boolean }>`
  background-color: white;
  color: ${colors.black};
  width: 192px;
  justify-content: flex-start;

  & svg {
    margin-right: 15px;

    & path {
      fill: ${(props) => (props.noFill ? 'none' : colors.black)};
    }
  }

  &:hover {
    background-color: ${colors.lighterGrey};
    color: ${colors.black};

    & svg {
      & path {
        fill: ${(props) => (props.noFill ? 'none' : colors.black)};
      }
    }
  }

  &:active {
    background-color: ${colors.lightGrey};
    color: ${colors.black};

    & svg {
      & path {
        fill: ${(props) => (props.noFill ? 'none' : colors.black)};
      }
    }
  }
`;

export const StyledDangerButton = styled(StyledButton)`
  color: ${colors.red};

  & svg {
    & path {
      fill: none;
    }
  }

  &:hover {
    color: ${colors.red};

    & svg {
      & path {
        fill: none;
      }
    }
  }

  &:active {
    color: ${colors.red};

    & svg {
      & path {
        fill: none;
      }
    }
  }
`;
